<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">银行账户</li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('122')"
        >添加</el-button
      >
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.name"
        style="width: 200px"
        placeholder="--关键字--"
        clearable
        @clear="
          delete state.params.name;
          onLoad();
        "
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态"
          :formatter="
            (row) =>
              $statusFormat({
                Text: row.status == 0 ? '停用' : '正常',
                Color: row.status == 0 ? '#f00' : '#1e90ff',
              })
          "
          width="140"
        />
        <el-table-column
          prop="name"
          sortable="name"
          label="名称"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          min-width="140"
        />
        <el-table-column
          prop="account"
          label="银行账号"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="opening_bank"
          label="开户行"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="received_amount"
          label="到账总额"
          :formatter="$tab_PriceFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="collected_amount"
          label="已认领金额"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="uncollected_amount"
          label="未认领金额"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="service_fee"
          label="手续费总额"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          label="操作"
          width="160"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth(['123', '124'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              v-if="$judge_auth('123')"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('124')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>

    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        :title="(state.selectId ? '修改' : '添加') + '到账银行'"
        @close="state.showInfo = false"
      >
        <c_BankAccountInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_BankAccountInfo>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { bankaccount_list, bankaccount_delete } from "@/http/bankaccount";
import { confirm_func } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      bankaccount_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(bankaccount_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
